/**
 * See PHP model constants SubscriptionPlan::LEVEL_*
 */
export enum SubscriptionPlanLevel {
  Freemium = 'freemium',
  Pro = 'pro',
  Business = 'business',
  Enterprise = 'enterprise',
  V2Solo = 'v2-solo',
  V2Team = 'v2-team',
  V2Business = 'v2-business',
}

/**
 * How frequently a User is charged when subscribed with a Subscription Plan.
 * See PHP model constants SubscriptionPlan::INTERVAL_*
 */
export enum SubscriptionPlanInterval {
  Monthly = 'monthly',
  Yearly = 'yearly',
}

/**
 * Essentially what "type" of Subscription Plan it is. We package/bundle our
 * Plans based on the core features they offer.
 *
 * @see app/Models/Subscription/SubscriptionPlanBundle.php
 */
export enum SubscriptionPlanBundle {
  AllInOne = 'all-in-one',
  Analysis = 'analysis',
}
